import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.css';

$("document").ready(function() {


  

  
  if ($('.hamburger').length > 0) {
    $('.hamburger').bind('click',function() { 
      
      $(this).toggleClass('is-active');
      $('.mobileMenu').slideToggle();
    
      return false;
    });

    $('.mobileMenu.menu-item-has-children a').click(function() { 
      $(this).parent().find('.sub-menu').slideToggle();
      $(this).toggleClass('active');
      return false;
    });

  

    
  }
  $('.scroller').click(function() { 
    $("html, body").animate({ scrollTop: 0 }, "fast");
    return false;
  });
  
  
  $('.feature .more').click(function() {  
    $(this).toggleClass('active');
   
    $('.featureShow').slideToggle();
    return false;
  });
  $('.feautered.blueBtn').click(function() { 
    var inst = $('[data-remodal-id=featuredremodal]').remodal();
    inst.open();
    return false;
  });
  $('.cta .blueBtn').click(function() { 
    var what = $(this).data('remodal');
    var inst = $('[data-remodal-id='+what+']').remodal();
    inst.open();
    return false;
  });
  $('.showmore').click(function() { 
    $(this).toggleClass('active');
   
    $(this).parent().find('.moreContent').slideToggle();
    return false;
  });
  



  if ($('.infoCarousel').length > 0) {
  
    $('.infoCarousel').slick({
      dots: false,
      arrows: false,
      infinite: true,
      speed: 300,
      variableWidth: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000,
      responsive: [
      {
          breakpoint: 991,
          settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          arrows: false,
          autoplay: true,
          autoplaySpeed: 4000,

          }
      }

      ]
  });

  }
  if ($('.gridCarousel').length > 0) {
  
    $('.gridCarousel').slick({
      dots: true,
      arrows: false,
      infinite: true,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
      {
          breakpoint: 991,
          settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false

          }
      }

      ]
  });

  }

  
  if ($('select').length > 0) {
    //$('select').niceSelect();
  }
  if ($('.gallery').length > 0) {
 
    $('a.gallery').featherlightGallery({
      previousIcon: '&#9664;',     
      nextIcon: '&#9654;',         
      galleryFadeIn: 100,          
      galleryFadeOut: 300          
    });
  }
  if ($('.selector').length > 0) {
    $('.selector .default').click(function() { 
      
      if($(this).hasClass('active')) {
        $('.selector .dropdown').hide();
        $('.selector .default').removeClass('active');
        
      } else {
        $('.selector .dropdown').hide();
        $(this).parent().find('.dropdown').slideToggle();
        $(this).toggleClass('active');
      }
      
  
    });
  }
  

  $('a[href*="#"]:not([href="#"])').click(function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
    var target = $(this.hash);
    target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
    if (target.length) {
        $('html, body').animate({
        scrollTop: target.offset().top-100
        }, 1000);
        return false;
    }
    }
});


function style(feature) {
  return {
      stroke:false

  };
}

/* Store locator */
const storeLocator = document.getElementById('stores');

if(storeLocator) {


window.addEventListener("DOMContentLoaded", () => {

  /**Map */
  let mymap = L.map('mapid').setView([47.2251218, 19.4352595], 8);

  //L.tileLayer('https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png', {
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    maxZoom: 18,
    tap: false,
    attribution: '&copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors'
  }).addTo(mymap);


 

  var markers = L.markerClusterGroup({ chunkedLoading: true });

  var icon = L.icon({
    iconUrl: map_options_pin,
    iconSize: [30, 75], 
  })

  if (map_options) {
    Array.prototype.forEach.call(map_options, opt => {
     // console.log('asd', opt)
      if (opt.lat && opt.long) {
        let latitude = parseFloat(opt.lat);
        let longitude = parseFloat(opt.long);
        markers.addLayer(L.marker([latitude, longitude], {
          
          'customer_name': opt.customer_name,
          'primary_address_city': opt.primary_address_street,
          'modal': opt.modal,
          'icon': icon
        }).bindPopup(`<strong>${opt.customer_name}</strong> ${opt.primary_address_city}<br /><a data-remodal-target="modal-${opt.modal}">Részletek</a> `));
      }
    })
  }
  mymap.addLayer(markers);


  countMarkers(markers);

  respMapSize(mymap)
  window.addEventListener('resize', function () {
    respMapSize(mymap)
  })

  function respMapSize(mymap) {
    let width = document.documentElement.clientWidth;
    if (width < 991) {
      mymap.setZoom(7);
    } else {
      mymap.setZoom(8);
    }
  }
  let cityselect = document.querySelectorAll('#helyszin-selector .optionh')
  let cityselectdefault = document.querySelector("#helyszin-selector .default")

  document.body.addEventListener("click", function (e) {
  
      if (e.target &&
          e.target.classList.contains("optionh")) {
   
            let cityselect = document.querySelectorAll('#helyszin-selector .optionh')
            let cityselectdefault = document.querySelector("#helyszin-selector .default")
        
             
                let tt = e.target.dataset.value
                let label = e.target.innerHTML;
        
                cityselectdefault.innerHTML = label; 
        
                for (var j = 0; j < cityselect.length; j++) {
                  cityselect[j].classList.remove('selected');
                }
                e.target.classList.add('selected');
              
                
                markers.clearLayers();
                let selectortwp = document.querySelector("#helyszin-selector .default");
                let selectDropdowntwp = document.querySelector("#helyszin-selector .dropdown");
                selectortwp.classList.remove('active');
                selectDropdowntwp.style.display = 'none';
               
          
                Array.prototype.forEach.call(map_options, opt => {
                  
                  
              
                  if (opt.lat && opt.long && tt == 'all') {
                    generateMarkers(opt)
                  }
                  else if(opt.customer_name == tt){
                    generateMarkers(opt)
                  }
          
                 
                })
                mymap.addLayer(markers);
                countMarkers(markers)
          
             
           
        }
    });

  const city = document.getElementById('city-selector')
  const region = document.getElementById('region-selector')
 



  const regionselect = document.querySelectorAll('#megye-selector .option')
  const regiondefault = document.querySelector("#megye-selector .default")

  const request = new XMLHttpRequest();
  
  if (regionselect) {
    
    for (var i = 0; i < regionselect.length; i++) {
      
      var current = regionselect[i];
      
      current.addEventListener('click', e => {
     
        let tt = e.target.dataset.value
        let label = e.target.innerHTML;

        regiondefault.innerHTML = label;

        for (var j = 0; j < regionselect.length; j++) {
          regionselect[j].classList.remove('selected');
        }
        e.target.classList.add('selected');
        cityselectdefault.innerHTML = "Összes helyszín";
        markers.clearLayers();
      
        let selector = document.querySelector(".selector .default");
        let selectDropdown = document.querySelector(".selector .dropdown");
        selector.classList.remove('active');
        selectDropdown.style.display = 'none';
       


        request.open('POST', admin_url, true);
        request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
        request.onload = function () {
            if (this.status >= 200 && this.status < 400) {
                // If successful
               // console.log(this.response);
                const helyszinDropdown = document.getElementById('helyszinDropdown');
                helyszinDropdown.innerHTML=this.response;
            } else {
                // If fail
                console.log(this.response);
            }
        };
        request.onerror = function() {
            // Connection error
        };
        request.send('action=filter_region&region=' + label);
      
        Array.prototype.forEach.call(map_options, opt => {
          
       
          if (opt.lat && opt.long && tt == 'all') {
            generateMarkers(opt)
          }
          else if(opt.region == tt){
            generateMarkers(opt)
          }
  
         
        })
        mymap.addLayer(markers);
        countMarkers(markers)
  
      })
    }


  }
  
  if (cityselect) {
    
/*     for (var i = 0; i < cityselect.length; i++) {
      
      var current = cityselect[i];
      
      current.addEventListener('click', e => {
     
        let tt = e.target.dataset.value
        let label = e.target.innerHTML;

        cityselectdefault.innerHTML = label;

        for (var j = 0; j < cityselect.length; j++) {
          cityselect[j].classList.remove('selected');
        }
        e.target.classList.add('selected');
      
        markers.clearLayers();
      

  
        Array.prototype.forEach.call(map_options, opt => {
          
       
          if (opt.lat && opt.long && tt == 'all') {
            generateMarkers(opt)
          }
          else if(opt.primary_address_city == tt){
            generateMarkers(opt)
          }
  
         
        })
        mymap.addLayer(markers);
        countMarkers(markers)
  
      })
    }*/


  }


  if (city) {
   
   /* city.addEventListener('change', e => {
      const tt = e.target.value

      markers.clearLayers();
    

    
      region.selectedIndex = 0;

      Array.prototype.forEach.call(map_options, opt => {
        const regionVal = region.value

        const isDefaultRegion = (regionVal === 'all' || regionVal === 'Válassz megyét')

        if (opt.lat && opt.long && tt == 'all' && isDefaultRegion) {
          generateMarkers(opt)
        }
        else if(isDefaultRegion && opt.primary_address_city == tt){
          generateMarkers(opt)
        }
        else if (opt.lat && opt.long && opt.primary_address_city == tt && opt.region == regionVal) {
          generateMarkers(opt)
        }

       
      })
      mymap.addLayer(markers);
      countMarkers(markers)

    })*/
  }

  if (region) {
    /*
    region.addEventListener('change', e => {
      const tt = e.target.value

      markers.clearLayers();
      

      city.selectedIndex = 0;
            

      Array.prototype.forEach.call(map_options, opt => {
        const cityVal = city.value

        const isDefaultCity = (cityVal === 'all' || cityVal === 'Válaszz helyszínt')

        if (opt.lat && opt.long && tt == 'all' && isDefaultCity) {
          generateMarkers(opt)
        }
        else if(isDefaultCity && opt.region == tt){
          generateMarkers(opt)
        }
        else if (opt.lat && opt.long && opt.region == tt && opt.primary_address_city == cityVal) {
          generateMarkers(opt)
        }
        
        
      })
      mymap.addLayer(markers);
      countMarkers(markers)

    })
    */
  }

  function countMarkers(markers) {
    const counter = document.getElementById('pincounter');
    if (counter) {
      counter.innerText = markers.getLayers().length
    }
  }

  function generateMarkers(opt) {
    let latitude = parseFloat(opt.lat);
    let longitude = parseFloat(opt.long);
    markers.addLayer(L.marker([latitude, longitude], {
     
      'customer_name': opt.customer_name,
      'primary_address_city': opt.primary_address_street,
      'modal': opt.modal,
      'icon': icon
    //}).bindPopup(`${opt.customer_code}`));
  }).bindPopup(`<strong>${opt.customer_name}</strong> ${opt.primary_address_city}<br /><a data-remodal-target="modal-${opt.modal}">Részletek</a> `));
  }

})


}




});
